<template>
  <section class="faq">
    <h1>Пройдите тестирование</h1>
    <div class="anketa-data" v-for="(item, index) in anketa" :key="index">
      <div class="question">{{ index + 1 }}. {{ item.desc }}</div>
      <div class="answers-wrapper">
        <div class="answer" v-for="(answ, i) in item.answers" :key="i">
          <label>
            <input :name="'q'+item.id" type="radio" v-model="answers[item.id]" :value="Number(answ.id)">
            <span> {{ answ.desc }} </span>
          </label>
          <p></p>
        </div>
      </div>
    </div>
    <div v-if="errors.length > 0" class="errors">
      <div v-for="(error, key) in errors" :key="key" class="error">
        {{ error }}
      </div>
    </div>
    <div v-if="!correct" class="btns-group">
      <makc-button @click.prevent="checkAnswers" class="primary">Проверить</makc-button>
    </div>
    <div v-if="correct" class="correct-text">
      <p>Тестирование пройдено успешно!</p>
      <p>Подпишите, пожалуйста, анкету с помощью СМС для продолжения.</p>
    </div>
    <div v-if="correct" class="sms">
      <sms-component
        :active="true"
        :view="'anketa'"
        :contract_id="contract_id"
        :other_params="{type:'prolongation_anketa'}"
        v-on:signed="signed"
      ></sms-component>
    </div>
  </section>
</template>

<script>
import SmsComponent from "@/profile/components/SmsComponent.vue";

export default {
  name: "AnketaComponents",
  props: ["anketa", "contract_id"],
  data: () => {
    return {
      correct: false,
      answers: {},
      errors: []
    };
  },
  methods: {
    signed() {
      location.reload();
    },
    async checkAnswers() {
      this.errors = [];
      // console.log (Object.keys(this.answers).length)
      if (Object.keys(this.answers).length < this.anketa.length) {
        this.errors.push("Ответы не на все вопросы выбраны");
        return;
      }
      const api = await this.$api2.get({
        action: "check-anketa",
        object: "cpa",
        anketa_result: this.answers,
        agreement_id: this.contract_id,
        token: this.$myApp.token.get()
      });
      // console.log(api);
      if (api.error) {
        this.errors = [];
        this.errors = api.errors;

      }
      if (api.success) {
        this.correct = true;
      }
    }
  },
  components: {
    SmsComponent
  }
};
</script>

<style scoped>
.question {
  padding-left: 15px;
  font-weight: 700;
}

.answers-wrapper {
  padding-left: 30px;
  padding-top: 15px;
  padding-bottom: 15px;
}
</style>